import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query';
import instance from 'config/interceptor';

export const getListSyncDataDelivery = async (params: UseBaseQueryOptions) => {
  const [, page, size] = params.queryKey || [];

  const { data } = await instance.get(`/SyncDataDelivery/${page}/${size}`);
  return data;
};

export const mutateSyncData = async (params: any) => {
  return await instance.put(`/SyncDataDelivery/SyncData`, params);
};

export const getDetailSyncDataDelivery = async (
  params: UseBaseQueryOptions
) => {
  const [, id, page, size] = params.queryKey || [];

  const { data } = await instance.get(
    `/SyncDataDelivery/${id}/${page}/${size}`
  );
  return data;
};

export const fetchCustomerPickup = async (): Promise<any[]> => {
  const { data } = await instance.get(
    "monitor/CustomerPickup"
  );
  return data;
};

const fetchDeliveryVendorPickupPage = async (
  custId: number,
  page: number,
  size: number
): Promise<number> => {
  const { data } = await instance.get(
    `/Delivery/DeliveryVendorPickup/${page}/${size}?CustomerId=${custId}`
  );
  return Array.isArray(data?.data) ? data.data.length : 0;
};

export const fetchDeliveryVendorPickupCount = async (
  custId: number,
  size = 200
): Promise<number> => {
  const { data: first } = await instance.get(
    `/Delivery/DeliveryVendorPickup/-1/${size}?CustomerId=${custId}`
  );

  const totalPages = Number(first?.totalPages ?? 0);
  if (!totalPages) return 0;

  const pages = Array.from({ length: totalPages }, (_, i) => i);
  const counts = await Promise.all(
    pages.map((p) => fetchDeliveryVendorPickupPage(custId, p, size))
  );

  return counts.reduce((a, b) => a + b, 0);
};

export const useTotalPickupCount = () =>
  useQuery<number>({
    queryKey: ["totalPickupCount"],
    queryFn: async () => {
      const customers = await fetchCustomerPickup();
      const perCustomerTotals = await Promise.all(
        customers.map((c: { custId: number }) =>
          fetchDeliveryVendorPickupCount(c.custId, 200)
        )
      );
      return perCustomerTotals.reduce((a, b) => a + b, 0);
    },
    staleTime: 60_000,
  });

export const mutateDownloadSyncData = async (params: {
  id: number;
}) => {
  const { id } = params;

  return instance.get(
    `SyncDataDelivery/DownloadReportSyncData/${id}`,
    {
      responseType: 'blob',
    }
  );
};

